<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div class="slds-is-relative">

  <div class="">
    <article class="slds-scrollable_x">
      <div class="">
        <div class="">

          <table class="slds-table slds-table_bordered">
            <tbody>
            <tr>
              <td class="content">C1</td>
              <td class="content">C2</td>
              <td class="content">C3</td>
              <td class="content">C4</td>
              <td class="content">C5</td>
            </tr>
            <tr>
              <td class="slds-cell-edit content">C1
                <div class="long">long</div>
              </td>
              <td class="content">C2</td>
              <td class="content">C3</td>
              <td class="content">C4</td>
              <td class="slds-cell-fixed content">C5
                <div class="long">long</div>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </article>
  </div>
  <div>something below</div>


</div>
